import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingsFromDeveloperLoadable } from './NewbuildingsFromDeveloperLoadable';
import { selectNewbuildingFromDeveloperIds } from '../../selectors/newObject';
import { selectIsNewbuildingPremiumRate } from '../../selectors/newbuildingPremiumRate';

export const NewbuildingsFromDeveloperLazy: React.FC = () => {
  const newbuildingIds = useSelector(selectNewbuildingFromDeveloperIds);
  const isPremium = useSelector(selectIsNewbuildingPremiumRate);

  if (!isPremium || !newbuildingIds.length) {
    return null;
  }

  return <NewbuildingsFromDeveloperLoadable />;
};
